export const derivativesRoutePaths = {
  list: {
    path: 'derivatives',
    fullPath: '/derivatives',
  },
  detail: {
    path: 'derivatives/:coin',
    fullPath: (coin: string) => `/derivatives/${coin}`,
  },
};
